/* eslint-disable camelcase */
import init_state from './init_state';
import reset_state from './reset_state';
import set_active_item from './set_active_item';
import set_active_key_result from './set_active_key_result';
import set_active_kpi from './set_active_kpi';
import set_active_objective from './set_active_objective';
import set_active_period_and_data from './set_active_period_and_data';
import set_sub_kpis from './set_sub_kpis.js';
import set_user from './set_user';
import update_preferences from './update_preferences';

export default {
  init_state,
  reset_state,
  set_active_item,
  set_active_key_result,
  set_active_kpi,
  set_active_objective,
  set_active_period_and_data,
  set_sub_kpis,
  set_user,
  update_preferences,
};
